import React, { useState } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  Modal,
  ModalInviteFriend,
  Page,
} from '../../components';
import StaticPage from '../../containers/StaticPage/StaticPage';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import { manageDisableScrolling, isScrollingDisabled } from '../../ducks/UI.duck';

import ReferralPageContentEn from './ReferralPageContentEn';

import css from './ReferralPage.module.css';

const ReferralPageComponent = props => {

  const { onManageDisableScrolling, currentUser } = props

  const [isInviteFriendOpen, setIsInviteFriendOpen] = useState(false)

  const handleInviteFriendOpen = () => {
    setIsInviteFriendOpen(true)
  }

  const handleInviteFriendClose = () => {
    setIsInviteFriendOpen(false)
  }

  return (
    <Page
      referrer="strict-origin-when-cross-origin"
      pageName='ReferralPage'
      currentUser={currentUser}
      title="Referral Page"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'ReferralPage',
        description: 'Refer your colleagues - AllCourse',
        name: 'Refer your colleagues',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <ReferralPageContentEn openModal={handleInviteFriendOpen} currentUser={currentUser} />

          <Modal
            id="TopbarInviteFriend"
            isOpen={isInviteFriendOpen}
            onClose={handleInviteFriendClose}
            usePortal
            onManageDisableScrolling={onManageDisableScrolling}
            closeButtonMessage={" "}
          >
            <ModalInviteFriend
              currentUser={currentUser}
              onManageDisableScrolling={onManageDisableScrolling}
            />
          </Modal>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {

  const { currentUser } = state.user;

  return {
    currentUser,
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) => dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

const ReferralPage = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(ReferralPageComponent);

export default ReferralPage;
